var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interval-navigation"},_vm._l((_vm.data),function(v){return _c('button',{key:v,class:{
      'interval-navigation__item': true,
      'interval-navigation__item--active': v === _vm.value,
    },attrs:{"value":v},on:{"click":_vm.onIntervalClick}},[_vm._v(" "+_vm._s(v)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }